import * as React from 'react';

function TaskManagementIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 4.025H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2h-2.25v1.5H19a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5h2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 3.725c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 15 7.475H9a1.75 1.75 0 0 1-1.75-1.75zM9 3.475a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h6a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zm7.555 6.795a.75.75 0 0 1-.05 1.06l-5.5 5a.75.75 0 0 1-.974.03l-2.5-2a.75.75 0 0 1 .938-1.17l2 1.6 5.027-4.57a.75.75 0 0 1 1.059.05"
  }));
}

export { TaskManagementIcon };
